import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7rjbb1n6aq: FaireBrandEntity = {
  token: "b_7rjbb1n6aq",
  type: "brand",
  name: "Legendairy Milk",
  avatarUrl:
    "https://cdn.faire.com/fastly/ba6b50aa5d7156fc98b9445e89aedd6a013fd62679f121372c9912b81094347a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6e206d920dd9bb5db7a10665add1fd1021f89858867a47572bd8cfe45e63ee6c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ba6b50aa5d7156fc98b9445e89aedd6a013fd62679f121372c9912b81094347a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6e206d920dd9bb5db7a10665add1fd1021f89858867a47572bd8cfe45e63ee6c.png",
  location: "Austin, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Born in the sleepless, milk-stained trenches of new momhood, Legendairy Milk® began when our founder, Luna Aziz, struggled with low milk supply and found no clean, effective solutions. So she took matters into her own hands—researching ancestral solutions, crafting herbal blends, and helping millions of moms along the way.\n\nToday, we’re more than lactation support. We deliver bold, science-backed solutions for every stage of womanhood—from trying to conceive, to postpartum, to “wait, is this perimenopause?”, and everything in between. Hydration? Check. Hair growth? Yep. Hormone Balance? Of course. \n\nNo topic is too taboo. No symptom is too small. Backed by science, steeped in generational wisdom, and served with a side of real talk, we exist to support women who refuse to settle for vague answers or outdated advice.\n\nWomen deserve better—and we’re just getting started.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:51.208Z",
    importedBy: "entity-db-cli",
  },
};
